module.exports = __webpack_public_path__ + "img/shebei3Pro.8680cc9e.png";